// extracted by mini-css-extract-plugin
module.exports = {"campaignCountDown":"ActionCampaigns_campaignCountDown__2V_5e"};